<template>
  <div>
    <el-dialog
      :title="lang.man_tag"
      :center="true"
      :visible="true"
      :close-on-click-modal="false"
			:show-close="true"
      width="500px"
			@close="close"
      class="addNewAppDialog"
      :append-to-body="true"
    >
      <div style="height: 100%;" class="add_box">
        <el-input v-model="add_new_tag"  @keyup.enter.native="handle_add_new_tag" :placeholder="lang.add_new_tag" class="anad_input">
					<!-- <template slot="append">
						<span style="cursor: pointer;" @click="handle_add_new_tag">{{ lang.new }}</span>
					</template> -->
				</el-input>
        <el-button type="primary" size="default" @click="handle_add_new_tag" style="margin-left: 10px;border: none;" v-loading="isloading">{{ lang.new }}</el-button>
      </div>
      <div class="tabBox">
					<div class="tb_item" v-for="(item) in labels_all_copy" :key="item.id">
						<span style="padding: 10px;" @keydown.enter="handleEnter($event, item)" :id="'a'+item.id" @blur="edit_label_put(item)">{{ item.name }}</span>
						<div>
              <div style="width: 18px;">
                <img class="editImg" style="display: none;cursor: pointer;" @click="edit_label(item)" src="@/assets/img/appCenter/edit_icon.svg">
              </div>
							<img @click="delete_label(item)" src="@/assets/img/appCenter/close_icon.svg">
						</div>
					</div>
				</div>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="close()">{{lang.close}}</el-button>
					<!-- <el-button type="primary" @click="close()">{{ lang.queding }}</el-button> -->
				</div>
			</template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    labels_all: Array,
  },
  data() {
    return {
      labels_all_copy:[],
      add_new_tag:"",
      isloading :false
    };
  },
  mounted() {
    this.labels_all_copy=this.labels_all;
  },
  methods: {
     // 处理回车键（阻止默认换行行为）
     handleEnter(e, item) {
      e.preventDefault(); // 禁止输入框内换行
      this.edit_label_put(item);
      e.target.blur();    // 可选：提交后自动失焦
    },
    edit_label(item){
      const label = document.getElementById(`a${item.id}`)
      label.contentEditable=true;
      label.focus()
      // 创建文本选择范围
      const range = document.createRange();
      range.selectNodeContents(label); // 选中元素内全部内容
      const selection = window.getSelection();
      selection.removeAllRanges(); // 清空现有选择
      selection.addRange(range);   // 应用新范围
    },
    edit_label_put(item){
      const label = document.getElementById(`a${item.id}`)
      const config = {
        method: 'put',
        url: this.new_url + "/api/labels/"+item.id,
        headers: {
          'Content-Type': 'application/json',
        },
        data:{
          "name": label.innerHTML,
          "userId": this.user.userId,
        }
      };
      this.$axios(config)
      .then((res) => {
          console.log(res)
          this.$emit("get_lable")
        })
        .catch((error) => {
          console.log(error);
        });
    },
    delete_label(item){
      // console.log(item)
      this.labels_all_copy=this.labels_all_copy.filter(value=>{
        return value.id !==item.id
      })
      const config = {
        method: 'delete',
        url: this.new_url + "/api/labels/"+item.id,
        headers: {
          'Content-Type': 'application/json',
        }
      };
      this.$axios(config)
      .then((res) => {
          console.log(res)
          this.$emit("get_lable")
        })
        .catch((error) => {
          console.log(error);
        });
    },
    close() {
      this.$emit("change_man_tag_flag",false)
      this.$emit("get_lable")
    },
    handle_add_new_tag(){
      if (!this.add_new_tag.trim()) return console.log('6');
      if (this.isloading) return 
      this.isloading = true
      // console.log('this.add_new_tag',this.add_new_tag.trim());
      
      //this.labels_all_copy.push({name:this.add_new_tag,id:})
      const config = {
        method: 'post',
        url: this.new_url + "/api/labels",
        headers: {
          'Content-Type': 'application/json',
        },
        data:{
          "name": this.add_new_tag,
          "userId": this.user.userId,
        }
      };
      this.$axios(config)
        .then((res) => {
          console.log(res)
          this.labels_all_copy.push(res.data)
          this.add_new_tag=""
          this.$emit("get_lable")
          this.isloading = false
        })
        .catch((error) => {
          this.isloading = false
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.labels{
  border-radius: 5px;
  border:1px solid #ccc;
}
.grid4 {
  display: grid;
  justify-content: space-around;
  grid-template-columns: 23% 23% 23% 23%;
  grid-gap: 10px;
  padding: 10px;
}
.addNewAppDialog >>> .el-dialog {
  min-width: 700px;

  /* height: 680px; */
  box-shadow: 0px 0 8px 0px #555555;
  border-radius: 8px;
  background-color: #fff;
  /* top: 0px; */
  /* margin: 0 auto; */
  overflow: hidden;
}
.addNewAppDialog >>> .el-dialog__body {
  height: 100%;
  min-width: 700px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding-bottom: 0px;
  padding-top: 10px;
	box-sizing: border-box;
	border-top: solid 1px #f3f7fd;
}
.addNewAppDialog >>> .el-dialog__header {
	min-width: 700px;
	text-align: left;
	
}

.a-d-top {
  /* background: #adadad; */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  border-radius: 8px 8px 0 0;
  user-select: none;
  border-bottom: 1px #ccc solid;
}

.a-d-topTit {
  /* width: 171px; */
  /* margin-left: 20px; */
  height: 32px;
  display: flex;
  font-weight: bold;
  font-size: 20px;
  align-items: center;
  font-family: PingFang SC;
  box-sizing: border-box;
  padding: 5px;
  line-height: 22px;
  justify-content: center;
  /* text-align: left; */
}

.a-d-t-right > span {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.tabBox{
	width: 100%;
	margin-top: 20px;
	height: auto;
	/* max-height: 400px; */
	margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.tb_item{
	box-sizing: border-box;
	padding: 0 15px;
	display: flex;
  justify-content: space-between;
  min-width: 100px;
	align-items: center;
	/* float: left; */
	margin-right: 15px;
	background-color: #F3F7FD;
	border: 1px solid #CDE0FE;
	border-radius: 4px;
	transition: .2s;
	color: #0354D7;
	margin-bottom: 10px;
}

.tb_item:hover{
	background-color: #fff;
}

.tb_item:hover .editImg{
	display: block !important;
}

.tb_item>div{
	display: flex;
	align-items: center;
	margin-left: 5px;
}

.tb_item>div>img{
	width: 18px;
	height: 18px;
	margin-left: 5px;
	cursor: pointer;
}

.dialog-footer{
	display: flex;
	justify-content: flex-end;
}

.anad_input>>>.el-input__inner{
	/* border-radius: 6px 0 0 6px; */
}

.anad_input>>>.el-input-group__append{
	/* border-radius: 0px 6px 6px 0px; */
}


.add_box{
  display: flex;
  align-items: center;
}
</style>
